import { render, staticRenderFns } from "./voiceGalleryProMobile.vue?vue&type=template&id=0bf52b8e&scoped=true"
import script from "./voiceGalleryProMobile.vue?vue&type=script&lang=js"
export * from "./voiceGalleryProMobile.vue?vue&type=script&lang=js"
import style0 from "./voiceGalleryProMobile.vue?vue&type=style&index=0&id=0bf52b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf52b8e",
  null
  
)

export default component.exports